module.exports = __webpack_public_path__ + "img/laptop-1.d64e82d3.svg";